import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ProgramAgreement } from './../interfaces/program-agreement';
import { HttpService } from './http.service';
import { ClubProgramCounters, ClubProgram, ProgramChangeStatus, ClubProgramIncomeCounter, SimpleClubProgram } from '../store';

@Injectable()
export class ProgramService {
  private _url = '/api/ClubProgram';

  constructor(private http: HttpClient, private httpService: HttpService) { }

  /* Get number of active, inactive, archive billiing programs. */
  getBillingProgramCounts(clubId: number) {
    return this.http.get<ClubProgramCounters>(this._url + '/get-billing-count/' + clubId);
  }

  getBillingProgramCountsByTypeId(clubId: number, typeId: number, teamID: number) {
    return this.http.get<ClubProgramCounters>(`${this._url}/get-billing-count-by-type/${typeId}/${clubId}?teamID=${teamID}`);
  }

  /* Get program listing. */
  getPrograms(): Observable<ClubProgram[]> {
    return this.http.get<ClubProgram[]>(this._url + '/Get');
  }

  getProgram(id: string | number): Observable<ClubProgram> {
    return this.httpService.get(this._url + '/show-program/' + id);
  }

  getProgramsByStatus(status: string | number, clubId: string | number, typeId: number = 1, teamID: number = 0): any {
    return this.http.get(`${this._url}/show-program-by-status-type/${status}/${typeId}/${clubId}`, { params: { teamID } } as any);
  }

  getProgramsByTeam(clubID: number, teamID: number) {
    return this.httpService.get(`${this._url}/get-team-programs/${clubID}/${teamID}`);
  }

  createProgram(club_program) {
    return this.httpService.post(this._url + '/create-program', club_program);
  }

  updateProgram(club_program) {
    return this.httpService.put(this._url + '/update-program', club_program);
  }

  deleteProgram(id: string) {
    return this.http.delete(this._url + '/delete-program/' + id);
  }

  deletePrograms(program_ids: string) {
    return this.http.delete(this._url + '/delete-programs/' + program_ids);
  }

  changeStatus(program_change_status: ProgramChangeStatus) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/change-status', program_change_status, httpOptions);
  }

  getClubStripeAccountId(clubId: number) {
    return this.http.get(this._url + '/billingInfo/' + clubId);
  }

  getStripeAccountId(programId: number) {
    return this.http.get(this._url + '/billingInfo/' + programId);
  }

  saveFormAgreement(programAgreement: ProgramAgreement) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.put(this._url + '/update-program-agreement', programAgreement, httpOptions);
  }

  getProgramAgreement(clubProgramID: number) {
    return this.http.get<ProgramAgreement>(this._url + '/show-program/' + clubProgramID);
  }

  getClubProgramIncomeCount(clubProgramID: number) {
    return this.http.get<ClubProgramIncomeCounter>(this._url + '/getClubProgramIncomeCount/' + clubProgramID);
  }

  getClubById(clubID: number) {
    return this.httpService.get(`${this._url}/club-by-id/${clubID}`);
  }

  getClubPlayers(clubID: number, teamID: number, programId: number = 0, paymentStatus: boolean = false) {
    return this.httpService.get(`${this._url}/club-players/${clubID}?teamID=${teamID || 0}`
      + (paymentStatus ? '&paymentStatus=1' : 'paymentStatus=0')
      + (programId ? '&programId=' + programId : '')
    );
  }

  getClubPlayersList(clubID: number, teamID: number, programId: number = 0) {
    return this.httpService.get(`${this._url}/club-players-list/${clubID}?teamID=${teamID || 0}`
      + (programId ? '&programId=' + programId : '')
    );
  }

  getPastDueMemberRegistrationStatus(clubID: number, clubProgramTypeID: number) {
    return this.httpService.get(`${this._url}/pastdue-member-registration-permission/${clubID}/${clubProgramTypeID}`);
  }

  updatePastDueMemberRegistrationStatus(clubID: number, clubProgramTypeID: number, option: number) {
    return this.httpService.put(`${this._url}/pastdue-member-registration-permission/${clubID}/${clubProgramTypeID}/${option}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/program.service.ts